'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.CANVAS_ELEMENT_ID = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _class; // React


// Utils


// Selectors


// Actions


// Components


// Constants


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _gridUtils = require('../utils/grid/gridUtils');

var _dontUpdateForKeys = require('../utils/milanoteRecompose/dontUpdateForKeys');

var _dontUpdateForKeys2 = _interopRequireDefault(_dontUpdateForKeys);

var _gridSizeSelector = require('../utils/grid/gridSizeSelector');

var _boardSelector = require('../element/board/boardSelector');

var _elementAttachmentActions = require('../element/elementAttachmentActions');

var _grabScrollDecorator = require('./grabScrollDecorator');

var _grabScrollDecorator2 = _interopRequireDefault(_grabScrollDecorator);

var _CanvasElement = require('./CanvasElement');

var _CanvasElement2 = _interopRequireDefault(_CanvasElement);

var _DocumentModeCanvasDebugger = require('../debug/documentMode/DocumentModeCanvasDebugger');

var _DocumentModeCanvasDebugger2 = _interopRequireDefault(_DocumentModeCanvasDebugger);

var _canvasLineEdgeDropTarget = require('../element/line/canvasLineEdgeDropTarget');

var _canvasLineEdgeDropTarget2 = _interopRequireDefault(_canvasLineEdgeDropTarget);

var _CanvasDragLayer = require('./dnd/CanvasDragLayer');

var _CanvasDragLayer2 = _interopRequireDefault(_CanvasDragLayer);

var _canvasDropTargetDecorator = require('./dnd/canvasDropTargetDecorator');

var _canvasDropTargetDecorator2 = _interopRequireDefault(_canvasDropTargetDecorator);

var _canvasShortcutElementDecorator = require('./canvasShortcutElementDecorator');

var _canvasShortcutElementDecorator2 = _interopRequireDefault(_canvasShortcutElementDecorator);

var _canvasSizeDecorator = require('./canvasSizeDecorator');

var _canvasSizeDecorator2 = _interopRequireDefault(_canvasSizeDecorator);

var _measureCanvasDecorator = require('../components/measurements/store/measureCanvasDecorator');

var _measureCanvasDecorator2 = _interopRequireDefault(_measureCanvasDecorator);

var _SelectionMarquee = require('./selection/SelectionMarquee');

var _SelectionMarquee2 = _interopRequireDefault(_SelectionMarquee);

var _selectionMarqueeCanvasStateDecorator = require('./selection/selectionMarqueeCanvasStateDecorator');

var _selectionMarqueeCanvasStateDecorator2 = _interopRequireDefault(_selectionMarqueeCanvasStateDecorator);

var _inboxConstants = require('../inbox/inboxConstants');

var _exportConstants = require('../workspace/header/utils/export/exportConstants');

require('./Canvas.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Canvas ID
var CANVAS_ELEMENT_ID = exports.CANVAS_ELEMENT_ID = 'canvas';

/* Redux property connectors. */
var mapStateToProps = (0, _reselect.createSelector)(_gridSizeSelector.getGridSize, _boardSelector.getIsCurrentBoardFetched, _boardSelector.getCurrentBoardInboxState, function (gridSize, isCurrentBoardFetched, currentBoardInboxState) {
    return {
        gridSize: gridSize,
        inboxState: isCurrentBoardFetched && currentBoardInboxState || _inboxConstants.INBOX_STATE.CLOSED
    };
});

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchErrorUploadingElementAttachment: function dispatchErrorUploadingElementAttachment(_ref) {
            var id = _ref.id,
                error = _ref.error;
            return dispatch((0, _elementAttachmentActions.errorUploadingElementAttachment)({ id: id, error: error }));
        }
    };
};

var getCanvasStyle = function getCanvasStyle(inboxState, gridSize) {
    return {
        right: inboxState === _inboxConstants.INBOX_STATE.OPEN ? (0, _gridUtils.gridPointsToPixels)(_inboxConstants.INBOX_WIDTH, gridSize) : 0
    };
};

var Canvas = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _dontUpdateForKeys2.default)(['canDrop', 'isHovered', 'isDragging', 'onCanvasResize', 'createShortcutElement']), (0, _grabScrollDecorator2.default)(_class = _dec(_class = (0, _canvasShortcutElementDecorator2.default)(_class = (0, _canvasDropTargetDecorator2.default)(_class = (0, _canvasLineEdgeDropTarget2.default)(_class = (0, _canvasSizeDecorator2.default)(_class = (0, _measureCanvasDecorator2.default)(_class = (0, _selectionMarqueeCanvasStateDecorator2.default)(_class = _dec2(_class = function (_React$Component) {
    _inherits(Canvas, _React$Component);

    function Canvas() {
        _classCallCheck(this, Canvas);

        return _possibleConstructorReturn(this, (Canvas.__proto__ || Object.getPrototypeOf(Canvas)).apply(this, arguments));
    }

    _createClass(Canvas, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.setShortcutHandlerCanvasNode(this.canvas);
        }
        // if current board changes, reset the canvas's scroll position

    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.currentBoardId !== nextProps.currentBoardId) {
                this.canvas.scrollLeft = 0;
                this.canvas.scrollTop = 0;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                canvasElementIds = _props.canvasElementIds,
                sortedCanvasElementIds = _props.sortedCanvasElementIds,
                connectDropTarget = _props.connectDropTarget,
                connectLineEdgeDropTarget = _props.connectLineEdgeDropTarget,
                gridSize = _props.gridSize,
                inboxState = _props.inboxState,
                currentBoardId = _props.currentBoardId,
                isEditable = _props.isEditable,
                elementFilter = _props.elementFilter,
                handleDoubleClick = _props.handleDoubleClick,
                grabEnabled = _props.grabEnabled,
                grabbing = _props.grabbing,
                deselectAll = _props.deselectAll,
                createShortcutElement = _props.createShortcutElement,
                createShortcutCard = _props.createShortcutCard,
                createShortcutImage = _props.createShortcutImage,
                createShortcutLink = _props.createShortcutLink,
                readyToMeasure = _props.readyToMeasure,
                selectionMarqueeActive = _props.selectionMarqueeActive,
                setSelectionMarqueeActive = _props.setSelectionMarqueeActive;


            var canvasClassNames = (0, _classnames2.default)('Canvas', {
                grab: grabEnabled,
                grabbing: grabbing,
                'selection-marquee-active': selectionMarqueeActive
            });

            return connectDropTarget(connectLineEdgeDropTarget(_react2.default.createElement(
                'div',
                { id: CANVAS_ELEMENT_ID, className: canvasClassNames,
                    style: getCanvasStyle(inboxState, gridSize),
                    onDoubleClick: handleDoubleClick,
                    ref: function ref(c) {
                        _this2.canvas = c;
                    } },
                _react2.default.createElement(
                    'div',
                    { className: 'scrollable-container',
                        id: _exportConstants.EXPORT_ROOT_ELEMENT_ID,
                        ref: function ref(c) {
                            _this2.scrollableContainer = c;
                        },
                        style: this.props.canvasSize },
                    canvasElementIds.map(function (elementId) {
                        return _react2.default.createElement(_CanvasElement2.default, {
                            sortIndex: sortedCanvasElementIds.indexOf(elementId),
                            readyToMeasure: readyToMeasure,
                            elementId: elementId,
                            key: elementId,
                            gridSize: gridSize,
                            currentBoardId: currentBoardId,
                            isEditable: isEditable,
                            deselectAll: deselectAll,
                            createShortcutElement: createShortcutElement,
                            createShortcutCard: createShortcutCard,
                            createShortcutImage: createShortcutImage,
                            createShortcutLink: createShortcutLink,
                            elementFilter: elementFilter });
                    }),
                    _react2.default.createElement(_CanvasDragLayer2.default, { currentBoardId: currentBoardId }),
                    _react2.default.createElement(_DocumentModeCanvasDebugger2.default, { gridSize: gridSize }),
                    _react2.default.createElement(_SelectionMarquee2.default, { canvasElementIds: canvasElementIds,
                        setSelectionMarqueeActive: setSelectionMarqueeActive,
                        eventListenerNode: this.scrollableContainer }),
                    _react2.default.createElement('div', { className: 'element-grab-blocker' })
                )
            )));
        }
    }]);

    return Canvas;
}(_react2.default.Component)) || _class) || _class) || _class) || _class) || _class) || _class) || _class) || _class) || _class);
exports.default = Canvas;


Canvas.propTypes = {
    currentBoardId: _propTypes2.default.string,
    canvasElementIds: _propTypes2.default.array,
    sortedCanvasElementIds: _propTypes2.default.array,
    inboxState: _propTypes2.default.string,
    connectDropTarget: _propTypes2.default.func,
    gridSize: _propTypes2.default.number,
    isOver: _propTypes2.default.bool,
    isEditable: _propTypes2.default.bool,
    onCanvasClick: _propTypes2.default.func,
    onCanvasResize: _propTypes2.default.func,
    handleDoubleClick: _propTypes2.default.func,
    deselectAll: _propTypes2.default.func,
    elementFilter: _propTypes2.default.object,
    connectLineEdgeDropTarget: _propTypes2.default.func,
    dispatchErrorUploadingElementAttachment: _propTypes2.default.func,
    grabEnabled: _propTypes2.default.bool,
    grabbing: _propTypes2.default.bool,
    createShortcutElement: _propTypes2.default.func,
    createShortcutCard: _propTypes2.default.func,
    createShortcutImage: _propTypes2.default.func,
    createShortcutLink: _propTypes2.default.func,
    canvasSize: _propTypes2.default.object,
    setShortcutHandlerCanvasNode: _propTypes2.default.func,
    setSizeHandlerCanvasNode: _propTypes2.default.func,
    readyToMeasure: _propTypes2.default.bool,
    selectionMarqueeActive: _propTypes2.default.bool,
    setSelectionMarqueeActive: _propTypes2.default.func
};


//////////////////
// WEBPACK FOOTER
// ./src/client/canvas/Canvas.js
// module id = 673
// module chunks = 0